import React from 'react';
import PropTypes from 'prop-types';

import noop from 'lodash/noop';

import Button from 'components/Button';
import Modal, { ModalHeader, ModalFooter } from 'components/Modal';

import './style.scss';

const DeleteXpackModal = ({ onCloseRequest, onDelete, isFetching }) => (
  <Modal closeOnEsc isOpen onCloseRequest={onCloseRequest}>
    <ModalHeader
      icon={<span className="icon-warning" styleName="icon-warning" />}
      subtitle={
        <span>
          <strong>Notice:</strong> Deleting an XPack also deletes all custom
          entries of XPack Entities.
        </span>
      }
      title={
        <span styleName="title">
          <div>You will delete all custom entries in xpack entities.</div>
          <div>Are you really sure?</div>
        </span>
      }
    />

    <ModalFooter justifyContent="flex-end">
      <Button
        isLarge
        isTransparent
        data-test="cancel-button"
        type="button"
        onClick={onCloseRequest}
      >
        Cancel
      </Button>

      <Button
        isLarge
        isWarning
        data-test="submit-button"
        isLoading={isFetching}
        type="button"
        onClick={onDelete}
      >
        Yes delete it
      </Button>
    </ModalFooter>
  </Modal>
);

DeleteXpackModal.propTypes = {
  onDelete: PropTypes.func.isRequired,
  isFetching: PropTypes.bool,
  onCloseRequest: PropTypes.func,
};

DeleteXpackModal.defaultProps = {
  isFetching: false,
  onCloseRequest: noop,
};

export default DeleteXpackModal;
